import { useEffect } from 'react'

import { createFileRoute } from '@tanstack/react-router'
import { match } from 'ts-pattern'

import ExtensionsInstitutionsPage from '@/components/pages/guest/_ext-intitutions/containers/extensions-institutions'
import { useFilters } from '@/components/pages/guest/_ext-intitutions/state/filters-atom'
import { searchParamsSchema } from '@/components/pages/guest/_ext-intitutions/types'

export const Route = createFileRoute('/_guest/guest/extensions-institutions/')({
  component: RouteComponent,
  validateSearch: searchParamsSchema
})

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const filters = useFilters()

  useEffect(() => {
    if (search.province_code) {
      filters.onProvinceChange(search.province_code, false)
    }
    if (search.city_code) {
      filters.onCityChange(search.city_code, false)
    }
    if (search.district_code) {
      filters.onDistrictChange(search.district_code, false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search.province_code, search.city_code, search.district_code])

  const activeTab = search.tab === 'province' || search.tab === 'city'
    ? 'bpp'
    : search.tab

  return (
    <ExtensionsInstitutionsPage
      activeTab={activeTab}
      onTabChange={tab => {
        const onChange = match(tab)
          .with('province', () => filters.reset)
          .with('city', () => filters.onProvinceChange)
          .with('bpp', () => filters.onCityChange)
          .with('posluhdes', () => filters.onDistrictChange)
          .otherwise(() => filters.reset)

        const code = match(tab)
          .with('province', () => search.province_code ?? '')
          .with('city', () => search.city_code ?? '')
          .with('bpp', () => search.district_code ?? '')
          .otherwise(() => '')

        onChange(code)
        navigate({ search: { ...search, tab } })
      }}
    />
  )
}
